import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import CustomTextFeild from '../common/CustomTextFeild'
import { getTheme } from '../redux/selectors/appSelectors';
import { useSelector } from 'react-redux';
import { apiRequest } from '../utils/config/apiRequest';
import { _apiUrls } from '../utils/endpoints/apiUrls';
import Search from '../assets/images/search.png'
import WhiteSearch from '../assets/images/whitesearch.png'
import Pagination from '../common/Pagination';

export default function Contact() {

  const theme = useSelector(getTheme);
  const isDarkMode = theme === 'dark';

  const [state, setState] = useState({ rows: [] });
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 5;

  const fetchContact = async () => {
    setLoading(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.contactUs,
      method: 'GET',
      query: {
        search: searchText,
        page: currentPage,
        limit: itemsPerPage
      }
    })
    if (status) {
      setState({ ...state, rows: data?.rows })
      setTotalItems(data?.count || 0);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchContact()
  }, [currentPage, searchText])



  return (
    <>

      <Row className='align-items-start'>
        <Col md={8} className='py-1'>
          <h4 className='dashheading'>Contact Us</h4>
          {/* <p className='dashsubheading'>Add/Contact Us</p> */}
        </Col>

        <Col md={4} className='py-1'>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <CustomTextFeild style={{
              padding: " 7px 13px",
              borderRadius: "10px", height: "auto",
            }}
              icon={isDarkMode ? WhiteSearch : Search}
              iconHeight="15px"
              placeholder='Search'
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value === '') {
                  setCurrentPage(1); // ✅ reset to first page on clear
                }
              }}
            />
          </div>
        </Col>

        <Col md={12} className='my-3'>
          <div className="head-border" />
        </Col>

        <Col md={12} className='mt-3'>
          <div className="table-responsive">
            <table className='admintable'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>email</th>
                  <th>message</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : state?.rows?.length > 0 ? (
                  state?.rows?.map((item, index) => (
                    <tr key={item?._id || index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item?.name || '---'}</td>
                      <td>{item?.mobileno || '---'}</td>
                      <td>{item?.email}</td>
                      <td>{item?.message}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      <p className='textwhite f-14 mb-0'>
                        No records found.
                      </p></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>

        <Col md={12} className='text-end mt-3'>
          <div className="d-flex justify-content-end">
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </Col>

      </Row>


    </>
  )
}
